import { IStageCapacityType } from "./general";

export interface IFilterItem {
  slug: string;
  label: string;
  options: IFilterOption[];
}

export interface IFilterOption {
  id: string;
  slug: string;
  label: string;
  icon?: JSX.Element;
}

export enum IFilterCategories {
  title = "title",
  country = "country",
  capacity = "capacity",
  capacityType = "capacityType",
  roomDimension = "roomDimension",
}

export interface IFilterCategoryOption extends IFilterOption {
  category: IFilterCategories;
}

export interface IVenueFilters {
  [IFilterCategories.title]?: string;
  [IFilterCategories.country]?: string | string[];
  [IFilterCategories.capacity]?: ICapacityOptions[];
  [IFilterCategories.capacityType]?: IStageCapacityType[];
  [IFilterCategories.roomDimension]?: IRoomDimensionsOptions[];
}

export enum ISortingOptionKeys {
  updatedAtDesc = "updatedAtDesc",
  titleAsc = "titleAsc",
}

export enum ICapacityOptions {
  "0_99" = "0_99",
  "100_499" = "100_499",
  "500_999" = "500_999",
  "1000_4999" = "1000_4999",
  "5000_9999" = "5000_9999",
  "10000_49999" = "10000_49999",
  "50000+" = "50000+",
}

export enum IRoomDimensionsOptions {
  "0_99" = "0_99",
  "100_999" = "100_999",
  "1000_4999" = "1000_4999",
  "5000_9999" = "5000_9999",
  "10000+" = "10000+",
}
